import { AxiosPromise } from 'axios';
import { CreateViewRequest, View } from '../../types/View';
import { libApiInstance } from '../axios';

export function requestViews(signal?: AbortSignal): AxiosPromise<View[]> {
    return libApiInstance.get('/views', { signal });
}

export function requestCreateView(
    data: CreateViewRequest,
    signal?: AbortSignal,
): AxiosPromise<View> {
    return libApiInstance.post('/views', data, { signal });
}

export function requestUpdateView(data: View, signal?: AbortSignal): AxiosPromise<boolean> {
    return libApiInstance.put(`/views/${data.viewId}`, data, { signal });
}

export function requestDeleteView(data: number, signal?: AbortSignal): AxiosPromise<boolean> {
    return libApiInstance.delete(`/views/${data}`, { signal });
}
